import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
type Props = {
  isDisabled: boolean;
  isErrored: boolean;
  isValidated: boolean;
  position: 1 | 2;
};
export const BirthDateInputSeparator = ({
  isDisabled,
  isErrored,
  isValidated,
  position,
}: Props) => (
  <span
    className={classnames('pointer-events-none absolute flex h-full items-center', {
      'text-success': isValidated && !isDisabled,
      'text-red': isErrored && !isDisabled,
    })}
    style={{
      left: `${(position / 3) * 100}%`,
    }}
  >
    /
  </span>
);
